export const archiveTicketMessages = {
  success: "Ticket archived successfully!",
  failure: "Failed to archive ticket!",
};

export const imageAltProps = {
  pdfIconAlt: "PDF Icon",
  archiveEllipsisAlt: "Archive Options",
  alertIconAlt: "Alert Icon",
  archiveIconAlt: "Archive Icon",
};
